import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as Button } from '../../Button/Button-BsLVZnfy.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useTaktId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const LeaveButton = ({
  onLeave,
  taktId,
  children,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    dataTaktId
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('leave-button')
  });
  return /*#__PURE__*/React__default.createElement(Button, _extends({
    variant: "primary"
  }, rest, {
    onClick: onLeave,
    taktId: dataTaktId
  }), children !== null && children !== void 0 ? children : formatMessage({
    id: 'leave_page'
  }));
};

export { LeaveButton as L };
//# sourceMappingURL=LeaveButton-Feih5mbA.js.map
